/**
 * ------------------------------------------------------------------------
 * PAGE TRANSITION JS
 * ------------------------------------------------------------------------
 */

/**
 * Variables
 * @type {Element}
 */
const layerLoading = document.querySelector('[data-js="layer-loading"]');
const layerTransition1 = document.querySelector('[data-js="layer-transition-1"]');
const layerTransition2 = document.querySelector('[data-js="layer-transition-2"]');

/**
 * Page transition function
 */
const pageTransition = () => {
    let updateEnter = false;
    let updatePreEnter = false;

    gsap.to(layerTransition1, {
        duration: 1,
        translateY: '-100%',
        autoRound: false,
        ease: 'Power4.easeOut'
    });

    gsap.to(layerTransition2, {
        duration: 1,
        delay: .2,
        translateY: '-100%',
        autoRound: false,
        ease: 'Power4.easeOut',
        onUpdate() {
            if (this.progress() <= .1) {
                if (updatePreEnter === false) {
                    layerLoading.remove();
                    document.querySelectorAll('[data-transition="element-pre-enter"]').forEach(function (element) {
                        element.classList.add('pre-enter');
                    });
                    updatePreEnter = true;
                }
            }
            if (this.progress() >= .5) {
                if (updateEnter === false) {
                    layerLoading.remove();
                    document.querySelectorAll('[data-transition="element-enter"]').forEach(function (element) {
                        element.classList.add('enter');
                    });
                    updateEnter = true;
                }
            }
        }
    });
};

window.addEventListener('load', () => {
    pageTransition();
});







// Seleziona l'elemento da monitorare
const compositionElement = document.querySelector('.homepage__ortofrutta__composition');

// Funzione per aggiungere la classe "active"
function addActiveClass() {
  compositionElement.classList.add('active');
}

// Funzione per rimuovere la classe "active"
function removeActiveClass() {
  compositionElement.classList.remove('active');
}

// Configura ScrollTrigger per aggiungere la classe "active" quando l'elemento è al centro della viewport
ScrollTrigger.create({
  trigger: compositionElement,
  start: 'top center', // L'elemento è al centro della viewport
  end: 'bottom top', // Opzionale: rimuovi la classe quando l'elemento esce dalla vista
  toggleClass: 'active', // Aggiungi o rimuovi la classe "active" automaticamente
});
